import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TraceService {
    constructor() {}

    private _enabled: boolean = false;

    isEnabled() {
        return this._enabled;
    }

    toggle() {
        this._enabled = !this._enabled;

        // Using console.log due to a circular reference with sdLogger.
        console.log('TraceService.toggleTracing(): ', {
            _enabled: this._enabled,
        });
    }
}
